<div class="header">
    <h2>Online Payments</h2>
</div>
<mat-card class="container-card mat-elevation-z0">
  <div class="card-wrap">
    <mat-card>
      <div>
        <h3 class="sub-heading">Select payment method</h3>
      </div>
      <br>
      <!-- <span class="step">1. Select the Gateway:</span> -->
      <div class="gateway-list">
        <a *ngFor="let gateway of availableGateways">
          <div class="gateway-btn {{paymentForm.get('gateway').value == gateway ? 'checked' : ''}}"
            (click)="setGateway(gateway)">
            <img src="{{gateway.logo}}" alt="{{ gateway.title }}" />
          </div>
        </a>
      </div>
      <br>
      <p class="note-text">
      <strong> Note: </strong> The Customer and the Third Party affirm that all payments shall comply fully with applicable U.S. laws and regulations, including, without limitation, those administered and enforced by the Office of Foreign Assets Control (“OFAC”). Such payments shall not involve individuals or entities designated as blocked persons or entities, nor shall they originate from or be directed to jurisdictions subject to U.S. sanctions, except as expressly authorized by OFAC’s general or specific licenses or other competent regulatory authorities.
The Customer further acknowledges and agrees that any noncompliance with these obligations may result in the EZ PIN’s refusal or reversal of payments. The EZ PIN reserves the right to request any additional documentation it deems necessary to verify compliance with U.S. sanctions laws and regulations.
      </p>
      <!-- <div *ngIf="showAmount">
        <span class="step">2. Amount:</span>
        <form [formGroup]="paymentForm">
          <mat-form-field appearance="outline">
            <mat-label>Amount <span *ngIf="selectedGateway.currency">({{ selectedGateway.currency?.symbol }})</span></mat-label>
            <input matInput formControlName="amount" placeholder="Amount" />
            <mat-hint><span *ngIf="selectedGateway.min_price">Minimum:
                {{selectedGateway.currency?.symbol}}{{selectedGateway.min_price | number}},</span>
                            <span *ngIf="selectedGateway.max_price"> Maximum:
                {{selectedGateway.currency?.symbol}}{{selectedGateway.max_price | number}}</span></mat-hint>
          </mat-form-field>
          <br />
          <br />
          <button mat-flat-button color="primary" [disabled]="paymentForm.invalid"
            (click)="initConfig()">Submit</button>
        </form>
      </div> -->

    </mat-card>
  </div>
</mat-card>
<app-online-payment-invoice-print [invoiceData]="bankTransferForm.value" #bankTransferInvoice></app-online-payment-invoice-print>

<ng-template #createPaymentEmail>
    <p>No PayPal® email found. In order to pay by PayPal®, you must specify your email account. Please note this email account cannot be changed.</p>
    <form [formGroup]="paymentEmailForm">
        <mat-form-field>
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" autocomplete="new-password" required />
        </mat-form-field>
        <button mat-raised-button color="primary" [disabled]="paymentEmailForm.invalid" (click)="setUserPaymentEmail()">Submit</button>
    </form>
</ng-template>

<ng-template #checkHiGift let-data>
    <h2 class="sub-heading">Pin Info</h2>
    <div class="redeem-wrap">
        <table class="check-card">
            <tbody>
                <tr>
                    <th>Amount</th>
                    <th><span class="amount"><span
                *ngIf="data?.remaining">{{data?.currency?.symbol}}</span>{{data?.remaining || '-'}}</span>
                    </th>
                </tr>
                <tr>
                    <th>Status</th>
                    <th><span>{{data?.status}}</span></th>
                </tr>
            </tbody>
        </table>
        <button mat-raised-button *ngIf="data?.remaining" [disabled]="data?.status_code !== hiGiftStatus.ACTIVE" color="primary" (click)="redeemHiGift(data)">Redeem</button>
        <button type="button" color="accent" (click)="closeDialogs()" mat-stroked-button>Cancel</button>

    </div>
</ng-template>

<ng-template #chequeConfirmDialog>
    <h2 class="sub-heading">Are you sure?</h2>
    <div class="redeem-wrap">
        <button mat-raised-button color="primary" (click)="submitCheque()">Yes</button>
        <button type="button" color="accent" (click)="closeDialogs()" mat-stroked-button>Cancel</button>
    </div>
</ng-template>

<ng-template #createPaymentDialog>
  <div class="create-payment-dialog">
    <div class="top-bar">
      <h3 class="sub-heading" *ngIf="checkVisibility(PaymentGateways.HIGIFT)"><strong>Redeem Gift Card</strong></h3>
      <div class="payment-header">
        <h3 class="sub-heading" *ngIf="!checkVisibility(PaymentGateways.HIGIFT)"><strong>Payment Information</strong>
        </h3>
        <button mat-raised-button color="primary" class="inline-item" *ngIf="selectedGateway.payment_method_type && selectedGateway.payment_method_type != 2" (click)="getCustomerPanelLink({gateway: selectedGateway?.id})"> Manage Card/Bank Account</button>
      </div>
      <br>
      <hr>
      <div *ngIf="selectedGateway" class="selected-gateway">
        <img [src]="selectedGateway?.logo">
        <div class="gateway-details">
          <p><b>{{ selectedGateway.title }}<span
            *ngIf="selectedGateway.currency">({{selectedGateway.currency?.code}})</span></b></p>
      <p *ngIf="selectedGateway.min_price"><b>Accepted Amount: </b>
        {{selectedGateway.currency?.symbol}}{{selectedGateway.min_price | number}} -
        {{selectedGateway.currency?.symbol}}{{selectedGateway.max_price | number}}
      </p>
      <p>{{ selectedGateway.description }}</p>
        </div>
      </div>
    </div>
    <div>
      <mat-spinner *ngIf="!gatewayReady" [diameter]="50"></mat-spinner>
      <div *ngIf="checkVisibility(PaymentGateways.PAYPAL_EMAIL_ERROR)">
        <hr />
        <h3 class="red-text">Attention!</h3>
        <p class="bold-text">The PayPal payment gateway is not active for you.  Please deposit $1 at <a href="mailto:paypal@ezpin.com">paypal@ezpin.com</a> to activate your PayPal payment gateway.  Then, send the transaction ID along with the email account, which you have paid the deposit to your account manager.</p>
      </div>
      <div *ngIf="checkVisibility(PaymentGateways.PAYPAL)">
        <small>*Payments only from the following account(s) would be approved:</small>
        <div *ngFor="let email of paymentEmailList">
          <small>
            <b>
              {{ email.email }}
            </b>
          </small>
        </div>
        <small>Contact to your account manager in order to change your email.</small>
      </div>
      <div class="methods-wrap" [hidden]="!gatewayReady">
        <div *ngIf="checkVisibility(PaymentGateways.PAYPAL)">
          <!-- <ngx-paypal [config]="payPalConfig"></ngx-paypal> -->
        </div>
        <div *ngIf="checkVisibility(PaymentGateways.BITPAY)" class="bitpay">
          <!-- <a (click)="initBitpayConfig()"> -->
          <img src="https://bitpay.com/cdn/en_US/bp-btn-pay.svg" />
          <!-- </a> -->
          <br />
          <small>*BitPay payments may take at least 60 mins to be confirmed.</small>
        </div>
  
        <div *ngIf="checkVisibility(PaymentGateways.MONEY_CHANGER)">
          <form [formGroup]="bankTransferForm" class="create-payment-form bank-transfer-form">
            <div class="amount-form">
              <mat-form-field  appearance="outline">
                <mat-label>Currency</mat-label>
                <mat-select formControlName="currency">
                  <mat-option *ngFor="let currency of bankTransferCurrencies" [value]="currency.symbol">{{currency.code}}({{currency.symbol}})</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Amount</mat-label>
                <input matInput type="text" formControlName="amount" placeholder="Amount" mask="separator.2" 
                [dropSpecialCharacters]="true" />
              </mat-form-field>
            </div>
            <mat-form-field  appearance="outline">
              <mat-label>Office</mat-label>
              <mat-select formControlName="office">
                <mat-option value="1">Usa</mat-option>
                <mat-option value="2">Dubai</mat-option>
              </mat-select>
            </mat-form-field>
            <br />
            <br />
            <div class="action-buttons">
              <button mat-stroked-button color="primary" (click)="closeDialogs()" type="button">Cancel</button>
              <button mat-flat-button color="primary" [disabled]="bankTransferForm.invalid"
              (click)="downloadBankTransferInvoice()" type="submit">Submit</button>
            </div>
          </form>
        </div>
        <div *ngIf="checkVisibility(PaymentGateways.HIGIFT)" class="hiGift-wrap create-payment-form">
          <p>Please enter your {{envrionmentConfig.title}} gift card code:</p>
  
          <form [formGroup]="hiGiftForm" (ngSubmit)="checkHiGiftPin()">
            <mat-form-field appearance="outline">
              <mat-label>Pin</mat-label>
              <input maxlength="19" matInput formControlName="pin" [value]="hyphenValue" required />
            </mat-form-field>
           <div class="action-buttons">
            <button mat-stroked-button color="primary" (click)="closeDialogs()" type="button">Cancel</button>
            <button color="primary" [disabled]="!hiGiftForm.valid" mat-raised-button type="submit">Submit</button>
           </div>
          </form>
        </div>
  
        <div *ngIf="checkVisibility(PaymentGateways.NGENIUS)" class="ngenius">
          <!-- <a (click)="initNGeniusConfig()"> -->
          <img src="/assets/images/ngenius.png" alt="NGenius" width="188px">
          <!-- </a> -->
        </div>
      </div>
    </div>
    <ng-container *ngIf="showAmount && !checkVisibility(PaymentGateways.MONEY_CHANGER)">
      <hr>
      <br><br>
      <div *ngIf="checkVisibility(PaymentGateways.CHEQUE)" class="cheque-wrap">
        <p>Please upload the image of your cheque:</p>
        <input type="file" style="display: none" (change)="onFileChanged($event)" #fileInput
          accept="image/png, image/jpeg, image/jpg" />
        <button mat-flat-button class="form-field" (click)="fileInput.click()" color="primary">
          Choose File
        </button>
        <div class="cheque-image-wrapper">
          <p> {{ paymentForm.value.image?.name  || "No file selected"}} </p>
          <img *ngIf="selectedImage" src="{{selectedImage}}" />
        </div>
        <!-- <button mat-flat-button class="form-field" (click)="openDialog(chequeConfirmDialog)"
          [disabled]="!paymentForm.value.image" color="primary">
          Upload
        </button> -->
        <br>
      </div>
      <div>
        <form [formGroup]="paymentForm" class="create-payment-form">
          <mat-form-field appearance="outline">
            <mat-label>Amount <span *ngIf="selectedGateway.currency">({{ selectedGateway.currency?.symbol }})</span></mat-label>
            <input matInput type="text" formControlName="amount" placeholder="Amount" mask="separator.2" 
            [dropSpecialCharacters]="true" />
            <mat-hint><span *ngIf="selectedGateway.min_price">Minimum:
                {{selectedGateway.currency?.symbol}}{{selectedGateway.min_price | number}},</span>
              <span *ngIf="selectedGateway.max_price"> Maximum:
                {{selectedGateway.currency?.symbol}}{{selectedGateway.max_price | number}}</span></mat-hint>
          </mat-form-field>
          <br />
          <br />
          <div class="action-buttons">
            <button mat-stroked-button color="primary" (click)="closeDialogs()" type="button">Cancel</button>
            <button mat-flat-button color="primary" [disabled]="paymentForm.invalid"
            (click)="checkGatewayType(selectedGateway)" type="submit">Submit</button>
          </div>
        </form>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #customerCardListDialog let-data>
    <div class="card-number-list">
      <h3>Select Your {{data.payment_method_type_text}}</h3>
      <p>
        Following {{data.payment_method_type_text}}(s) are registered in your account for payment. Please
        choose one to finalize your order.
      </p>
     <div class="card-list-container">
      <a
      *ngFor="let card of customerCardList"
      (click)="initConfig(card.method_id)"
    >
      <div class="bank-card">
        <p>{{ card.card_number }}</p>
      </div>
    </a>
     </div>
    </div>
    <hr>
    <!-- <button mat-raised-button color="primary" (click)="getCustomerPanelLink()">Add New {{selectedGateway?.payment_method_type_text}}</button> -->
    <button mat-raised-button color="primary" class="inline-item" (click)="getCustomerPanelLink({'gateway': selectedGateway?.id})"> Manage Card/Bank Account</button>
</ng-template>